import { useEffect, useState } from 'react';
import { getStorageAccessSignature } from './storageAccess';

/**
 * Fetches the read signature (SAS token query string) of a private storage
 * container. Signatures are shared and cached across components.
 */
const useStorageAccessSignature = (containerName: string | undefined) => {
  const [data, setData] = useState<string | undefined>();
  const [isFetching, setIsFetching] = useState<boolean>(!!containerName);

  useEffect(() => {
    if (!containerName) {
      setIsFetching(false);
      return;
    }
    let cancelled = false;
    setIsFetching(true);
    getStorageAccessSignature(containerName)
      .then((signature) => !cancelled && setData(signature))
      .catch(() => !cancelled && setData(undefined))
      .finally(() => !cancelled && setIsFetching(false));
    return () => {
      cancelled = true;
    };
  }, [containerName]);

  return { data, isFetching };
};

export default useStorageAccessSignature;
